import { render } from "./CustomerOrderReport.vue?vue&type=template&id=946d2a3e"
import script from "./CustomerOrderReport.vue?vue&type=script&lang=js"
export * from "./CustomerOrderReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__